import { assignLocationList } from "constants/assignLocation";

const initialState = {
  assignLocationList: {},
};

const assignLocation = (state = initialState, action) => {
  switch (action.type) {
    case assignLocationList:
      return { ...state, assignLocationList: action.payload };
    default:
      return state;
  }
};

export default assignLocation;
